// SELF-CONTAINED — must NOT import i18n, signals, or notifications.
// Spec §5.13 invariant: an error in those modules cannot prevent fallback render.
import { audio } from '@/audio-singleton';

export function ChromeFallback() {
  return (
    <div class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#1a3a5c] text-white p-6 text-center">
      <h2 class="text-xl font-bold mb-3">Hiba történt — frissítsd az oldalt</h2>
      <p class="text-sm mb-5 opacity-80">Something went wrong — please refresh</p>
      <button
        class="px-4 py-2 bg-white text-[#1a3a5c] rounded-lg font-semibold"
        onClick={() => { audio().play('tap'); window.location.reload(); }}
      >Frissítés / Refresh</button>
    </div>
  );
}
